<div *ngIf="anyDisplay" class="mt-3">
  <ng-container *ngIf="extraHeightDisplay?.length > 0">
    <ng-container
      *ngTemplateOutlet="
        labelAndText;
        context: {
          label: 'Extra materiaal',
          text: extraHeightDisplay,
          outerDivClass: applyOtherOrderMargin ? 'mt-3 warning' : 'warning',
          showArrowAssets: false
        }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="arrowsAmountDisplay?.length > 0">
    <ng-container
      *ngTemplateOutlet="
        labelAndText;
        context: {
          label: 'Pijltjes',
          text: arrowsAmountDisplay,
          outerDivClass: applyOtherOrderMargin ? 'mt-3' : '',
          showArrowAssets:
            installerView &&
            !arrowsLocationDisplay?.length > 0 &&
            !arrowsDesignDisplay?.length > 0
        }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="arrowsLocationDisplay?.length > 0">
    <ng-container
      *ngTemplateOutlet="
        labelAndText;
        context: {
          label: 'Pijltjes locatie',
          text: arrowsLocationDisplay,
          outerDivClass: '',
          showArrowAssets: installerView && !arrowsDesignDisplay?.length > 0
        }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="arrowsDesignDisplay?.length > 0">
    <ng-container
      *ngTemplateOutlet="
        labelAndText;
        context: {
          label: 'Pijltjes ontwerp',
          text: arrowsDesignDisplay,
          outerDivClass: '',
          showArrowAssets: true
        }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="secondBoardPlacementDisplay?.length > 0">
    <ng-container
      *ngTemplateOutlet="
        labelAndText;
        context: {
          label: 'Tweede bord',
          text: secondBoardPlacementDisplay,
          outerDivClass: applyOtherOrderMargin ? 'mt-3' : '',
          showArrowAssets: false
        }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="secondBoardConfigurationDisplay?.length > 0">
    <ng-container
      *ngTemplateOutlet="
        labelAndText;
        context: {
          label: 'Tweede bord configuratie',
          text: secondBoardConfigurationDisplay,
          outerDivClass: '',
          showArrowAssets: false
        }
      "
    ></ng-container>
  </ng-container>

  <ng-container *ngIf="otherOrderDisplay?.length > 0">
    <ng-container
      *ngTemplateOutlet="
        labelAndText;
        context: {
          label: 'Andere bestelling',
          text: otherOrderDisplay,
          outerDivClass: applyOtherOrderMargin ? 'mt-3' : '',
          showArrowAssets: false
        }
      "
    ></ng-container>
  </ng-container>
</div>

<ng-template
  #labelAndText
  let-label="label"
  let-text="text"
  let-outerDivClass="outerDivClass"
  let-showArrowAssets="showArrowAssets"
>
  <div [ngClass]="outerDivClass">
    <span class="preserve-line-break display-contents">
      <span>{{ label }}: </span>

      <span class="strong inline-flex">{{ text }}</span>
    </span>

    <div
      *ngIf="showArrowAssets && arrowAssets?.length > 0"
      class="arrow-images mt-1 mb-2"
    >
      <img
        *ngIf="isImage(arrowAssets[0])"
        class="max-summary-width max-summary-height clickable"
        src="/api/assets/{{ arrowAssets[0].uuid }}"
        (click)="openLightbox()"
      />
    </div>
  </div>
</ng-template>
